import React, { useEffect, useState, useCallback, useContext, useRef } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, TextField, InputLabel, Button, Modal, IconButton, Alert } from "@mui/material"
import BackIcon from "../../../components/BackIcon"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import ExcelImportar from "../../../assets/iconos/ExcelImportar.ico"
import Swal from "sweetalert2"
import { useNavigate, Navigate } from "react-router-dom"
import { MaterialReactTable } from "material-react-table"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import CustomTooltip from "../../../components/ToolTip"
import BuscarIcon from "../../../assets/iconos/Buscar.ico"
import { FaImage } from "react-icons/fa6"
import ProductoAddIcon from "../../../assets/iconos/ProductoAdd.ico"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import CustomDatePicker from "../../../components/CustomDatePicker"
import dayjs from "dayjs"
import CustomTextField from "../../../components/CustomTextField"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import { FilterRounded } from "@mui/icons-material"
import CustomHelperDetails from "./CustomHelperDetails"
import { filter } from "mathjs"
import DatagridEgresoDetalle from "../components/DataGridEgresoDetallle"
import Lotes from "../../Picking/components/Lote"
import CustomBackdrop from "../../../components/CustomBackdrop"
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87",
    },
  },
})

const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Egreso Egreso Egreso Egreso FechaI FechaI FechaI FechaI TransaccionI TransaccionI TransaccionI TransaccionI"
    "Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle"
    "Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso"
    
  `,
  gap: "8px",
  alignItems: "center",
}))

const Egreso = styled(Box)({
  gridArea: "Egreso",
})

const FechaI = styled(Box)({
  gridArea: "FechaI",
})
const Detalle = styled(Box)({
  gridArea: "Detalle",
})
const TransaccionI = styled(Box)({
  gridArea: "TransaccionI",
})

const Ingreso = styled(Box)({
  gridArea: "Ingreso",
})

const Fecha = styled(Box)({
  gridArea: "Fecha",
})
const Picking = styled(Box)({
  gridArea: "Picking",
})

const CrearEgreso = () => {
  const [articulos, setArticulos] = useState([])
  const [filtros, setFiltros] = useState({
    ingreso: {},
    egreso: "",
    detalle: "",
    articulo: {},
    fecha: dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
    fechaIngreso: dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
  })
  const [cliente, setCliente] = useState("")
  const [bodega, setBodega] = useState("")
  const [inv, setInv] = useState("")
  const [metodoTransaccion, setMetodo] = useState(0)
  const [origenTransaccion, setOrigen] = useState("")

  useEffect(() => {
    filtros.ingreso.fechaIngreso = filtros.ingreso.trafecha
  }, [filtros.ingreso])
  const handleSetFiltros = (key, value) => {
    if (filtros[key] !== value) {
      setFiltros((prev) => ({ ...prev, [key]: value }))
    }
  }
  const {
    data: dataArticulos = [],
    isError: dataArticulosError,
    isFetching: isFetchingArticulos,
    isLoading: isLoadingArticulos,
    refetch: refetchGetAllArticulos,
  } = useGetAllArticulos()
  function useGetAllArticulos() {
    return useQuery({
      queryKey: ["articulosAsociadosAIngreso"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            tranumero: filtros.ingreso.tranumero,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("datos enviados al request a ntes de la llamada", options.body)
        let response = await fetchwrapper(`/EgresoPicking/getDetalleEgresoPicking`, options)
        response = await response.json()
        console.log("datos enviados al request", options.body)
        console.log("datos devueltos de la api", response.data)
        return response.data
      },
      enabled: !!filtros.ingreso.tranumero,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  useEffect(() => {
    setBodega(bodega)
    setInv(inv)
    setCliente(cliente)
    setMetodo(metodoTransaccion)
    setOrigen(origenTransaccion)
    console.log(bodega, inv, cliente, metodoTransaccion, origenTransaccion)
  }, [bodega, inv, cliente, metodoTransaccion, origenTransaccion])
  useEffect(() => {
    // Solo actualiza bodegas si dataBodegas tiene valores
    if (dataArticulos.length > 0) {
      setArticulos(dataArticulos)
      const articulo = dataArticulos[0]
      setBodega(articulo.bodcodigo)
      setInv(articulo.invcodigo)
      setCliente(articulo.clipicking)
      setMetodo(articulo.trametodo)
      setOrigen(articulo.traorigen)
      console.log("useeffect")
    }
  }, [dataArticulos])
  useEffect(() => {
    refetchGetAllArticulos()
  }, [filtros.ingreso.tranumero])
  const { data, refetch } = useGenerarNumSecuencia()
  const [inputValue, setInputValue] = useState("")
  function useGenerarNumSecuencia() {
    return useQuery({
      queryKey: ["EgresoPorPickingNumSecuencia"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            codDocumento: "EGR",
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper("/EgresoPicking/generarNumSecuencia", options)
        response = await response.json()
        response = response?.data
        return response
      },
      refetchOnWindowFocus: false,
      enabled: false,
    })
  }

  useEffect(() => {
    refetch()
  }, [])
  const navigate = useNavigate()
  const handleChange = (event) => {
    setInputValue(event.target.value)
  }
  const { mutateAsync: createEgresoPicking, isPending: isCreatingEgresoPicking } = useCreateEgresoPicking()
  const { mutateAsync: actualizarSecuenciaEgreso } = useActualizarSecuenciaEgreso()
  function useActualizarSecuenciaEgreso() {
    return useMutation({
      mutationFn: async () => {
        const options = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper("/EgresoPicking/actualizarSecuenciaEgreso", options)
        response = await response.json()
        if (response.error) {
          console.log("Error updating sequence", response.error)
        }
        return response
      },
    })
  }
  function useCreateEgresoPicking() {
    return useMutation({
      mutationFn: async () => {
        console.log("ingreso filtros", filtros.ingreso)
        // send api update request here
        const options = {
          method: "POST",
          body: JSON.stringify({
            tranumero: data,
            codIngreso: filtros.ingreso.tranumero,
            ordnumero: filtros.ingreso.ordnumero,
            tradescripcion: filtros.detalle,
            fechaEgreso: filtros.fechaInicial,
            clicodigo: cliente,
            bodcodigo: bodega,
            invcodigo: inv,
            detalles: dataArticulos,
            trametodo: metodoTransaccion,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log(options.body)
        let response = await fetchwrapper("/EgresoPicking/saveCabeceraEgreso", options)
        response = await response.json()
        if (response.error) {
          console.log("response", response.error)
        }
        return response
      },
      onSuccess: async () => {
        alert("Egreso de picking creado con éxito")
        await actualizarSecuenciaEgreso()
        navigate("/home/dashboard/EgresoPicking")
      },
      onError: () => {
        alert("No se pudo crear el egreso de picking")
        navigate("/home/dashboard/EgresoPicking")
      },
    })
  }

  const handleSaving = () => {
    createEgresoPicking()
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon returnUrl="/home/dashboard/EgresoPicking" />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
            <CustomTooltip title={"Crear Egreso"}>
              <Button onClick={handleSaving}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Crear Egreso Por Picking</b>
        </div>

        <Container>
          <Egreso>
            <InputLabel htmlFor="solicitud">Solicitud</InputLabel>
            <TextField id="solicitud" value={data} onChange={handleChange} required fullWidth disabled />
            <CustomBackdrop isLoading={isCreatingEgresoPicking} />
          </Egreso>
          <FechaI>
            <CustomDatePicker
              label="Fecha
              "
              value={filtros.fechaInicial}
              setValue={(v) => handleSetFiltros("fechaInicial", v)}
              isOptional={true}
            />
          </FechaI>
          <TransaccionI>
            <InputLabel htmlFor="transaccion">Transaccion</InputLabel>
            <TextField id="transaccion" value={"EGRESO SGA POR SOLICITUD"} required fullWidth disabled />
          </TransaccionI>
          <Detalle>
            <CustomTextField
              label="Detalle"
              value={filtros.detalle}
              setValue={(v) => handleSetFiltros("detalle", v)}
              fullwidth
            />
          </Detalle>
          <Ingreso>
            <CustomHelperDetails
              label="Ingreso"
              valueSearched={filtros.ingreso?.tranumero}
              endpoint="/EgresoPicking/getPickingHelper"
              valueInputMain="tranumero"
              valueInputSecondary="tradescripcion"
              valueInputDate="trafecha"
              valueInputPicking="ordnumero"
              idSearchField="tranumero"
              errorMsgIdSearch="Error fetching data:"
              errorMsgFilterSearch="Error en cargar datos"
              queryKeyModal="EgresoPickingCrearAyuda"
              perPage={10}
              placeholder=""
              columnsTable={[
                {
                  accessorKey: "tranumero",
                  header: "Ingreso",
                  size: 100,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <span>{value}</span>
                  },
                },
                {
                  accessorKey: "ordnumero",
                  header: "Picking",
                  size: 100,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <span>{value}</span>
                  },
                },
                {
                  accessorKey: "trafecha",
                  header: "Fecha de emision",
                  size: 250,
                  Cell: ({ cell }) => {
                    const cellValue = cell.getValue()
                    return normalFormatDate(cellValue)
                  },
                },
                {
                  accessorKey: "tracantidad",
                  header: "Cantidad de Ingreso",
                  size: 150,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <span>{value}</span>
                  },
                },
                {
                  accessorKey: "artpickcantidad",
                  header: "Teléfono",
                  size: 100,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <span>{value}</span>
                  },
                },
                {
                  accessorKey: "tratipo",
                  header: "Dirección",
                  size: 400,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <p>{value}</p>
                  },
                },
                {
                  accessorKey: "tracodigo",
                  header: "Referencia Rápida",
                  size: 120,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <p>{value}</p>
                  },
                },
                {
                  accessorKey: "tradocumento",
                  header: "Zona",
                  size: 120,
                  Cell: ({ cell }) => {
                    const value = cell.getValue()
                    return <span>{value}</span>
                  },
                },
              ]}
              onHandleSelectedData={(v) => handleSetFiltros("ingreso", v)}
              sxInputMain={{
                minWidth: "170px",
                maxWidth: "190px",
                marginRight: "10px",
              }}
              sxInputSecondary={{
                width: "100%",
              }}
            />
          </Ingreso>
        </Container>
        <DatagridEgresoDetalle
          fetchedInfo={dataArticulos}
          isLoadingInfoError={dataArticulosError}
          isLoadingInfo={isLoadingArticulos}
          isFetchingInfo={isFetchingArticulos}
          columnsTable={[
            {
              accessorKey: "sgapicking",
              header: "Factura/Solicitud",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "clipicking",
              header: "Código Cliente",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "artcodigo",
              header: "Código Articulo",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "artdescri",
              header: "Descripcion",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "lotes",
              header: "Series Lote",
              size: 100,
              Cell: ({ row }) => (
                <Lotes
                  artdiasseg={0}
                  maxCantidadEmbalaje={Number(row.original.sgacansolfac)}
                  setLotesInProducto={() => {}}
                  initialLotes={row.original.lotes}
                  cantidadLoteInitial={Number(row.original.tracantidad)}
                ></Lotes>
              ),
            },

            {
              accessorKey: "lotes",
              header: "Lotes",
              size: 150,
              Cell: ({ cell }) => {
                // Extraemos el valor de la celda, que es un array de lotes
                const lotes = cell.getValue()

                // Si `lotes` es un array, lo mapeamos para generar las opciones
                return (
                  <Select defaultValue="" value={"Lotes"} fullWidth>
                    {lotes.map((lote, index) => (
                      <MenuItem key={index} value={lote.artlote}>
                        {`Lote: ${lote.artlote} | Cantidad: ${lote.artcantlote}`}
                      </MenuItem>
                    ))}
                  </Select>
                )
              },
            },

            {
              accessorKey: "tracantidad",
              header: "Cantidad solicitada",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "sgacansolfac",
              header: "Cantidad Picking",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
          ]}
        />
      </div>
    </ThemeProvider>
  )
}

export default CrearEgreso
